<template>
  <div v-if="!loadingState" class="d-flex flex-column h-100">
    <navigation-top/>

    <div v-if="starredWorkflows?.length > 0" style="margin-top: 38px; margin-bottom: 24px;">
      <div style="margin-bottom: 18px;">Starred Workflows</div>
      <div class="dashboard-grid-layout">
        <dashboard-workflow-card
          v-for="workflow in starredWorkflows"
          :key="workflow.id"
          :workflow="{ ...workflow, projectName: project?.name, organisationName: project?.organisation?.name }"
          @edit="editWorkflow"
        ></dashboard-workflow-card>
      </div>
    </div>

    <div style="margin-top: 38px; margin-bottom: 24px;">
      <div style="margin-bottom: 18px;">{{ starredWorkflows?.length > 0 ? 'Other workflows' : 'All Workflows' }}</div>
      <div class="dashboard-grid-layout">
        <workflow-dialog ref="dialogWorkflow" :setWorkflow="true" v-if="subscriptionAccessType === 'FULL'">
          <template #activator="{ props }">
            <div v-bind="props" class="dashboard-card text-new-button d-flex flex-column justify-center align-center">
              <v-icon style="font-size: 40px;" class="mb-2">mds:add</v-icon>
              New Workflow
            </div>
          </template>
        </workflow-dialog>

        <dashboard-workflow-card
          v-for="workflow in notStarredWorkflows"
          :key="workflow.id"
          :hide-actions="subscriptionAccessType !== 'FULL'"
          :workflow="{ ...workflow, projectName: project?.name, organisationName: project?.organisation?.name }"
          @edit="editWorkflow"
        ></dashboard-workflow-card>
      </div>
    </div>

    <!-- <div class="dashboard-container pa-6 ma-0 mt-3 d-flex flex-column" style="min-height: 290px;">
      <div class="text-h5 font-weight-bold pb-4">Project Goals</div>
      <goal-list
        ref="goalList"
        placeholder="You have not added any goals in this project yet."
        :goals="project?.goals || []"
        @changed="updateGoals"
      ></goal-list>
      <div class="d-flex justify-end mt-4 mt-auto">
        <v-btn @click="userAddGoal" color="primary">Add project goal</v-btn>
      </div>
    </div> -->

    <!-- <dashboard-ai-project
      :insideProject="true"
    ></dashboard-ai-project> -->

    <div class="dashboard-container-alt d-flex flex-column pb-10" style="padding-top: 48px; margin-top: 40px;">
      <div class="d-flex">
        <v-icon class="pt-4 mr-2">mds:account-circle</v-icon>
        <div class="pt-3">Project members</div>

        <v-spacer/>
        <invite-team-member-dialog>
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              variant="outlined"
              size="large"
            >
              <v-icon class="mr-2">mds:group_add</v-icon>
              Invite members
            </v-btn>
          </template>
        </invite-team-member-dialog>
      </div>

      <v-data-table
        style="margin-top: 24px;"
        :headers="projectMemberHeaders"
        :items="[...activeMembers, ...pendingMembers]"
        :items-per-page="-1"
      >
        <template v-slot:bottom></template>

        <template #item="props">
          <tr :class="{'highlight-owner' : isProjectOwner(props.item, project)}">
            <template v-if="props.item.user">
              <td>{{ props.item.user.email }}</td>
              <td>
                {{ props.item.user.firstname }} {{ props.item.user.lastname }}
                <v-tooltip v-if="isProjectOwner(props.item, project)" location="bottom">
                  <template v-slot:activator="{ props: innerProps }">
                    <span v-bind="innerProps"> (Project Owner)</span>
                  </template>
                  <span>The owner of this project.</span>
                </v-tooltip>
                <v-tooltip v-if="isLoggedInUser(props.item)" location="bottom">
                  <template v-slot:activator="{ props: innerProps }">
                    <span class="font-weight-bold" v-bind="innerProps"> (You)</span>
                  </template>
                  <span>This logged in user.</span>
                </v-tooltip>
              </td>
            </template>
            <template v-else>
              <td>{{ props.item.email }}</td>
              <td><i>Not yet logged in</i></td>
            </template>
            <td>{{ props.item.user?.company || '-' }}</td>
            <td>{{ props.item.user?.job || '-' }}</td>
            <td>
              <v-menu>
                <template #activator="{ props }">
                  <v-btn
                    variant="text"
                    icon="mds:more_horiz"
                    v-bind="props"
                  />
                </template>
                <v-list>
                  <v-list-item
                    :disabled="isProjectOwner(props.item, project)"
                    @click="showDeleteTeamMemberDialog($router, props.item, project.id)"
                  >
                    <v-list-item-title>Remove from project <span v-if="isProjectOwner(props.item, project)">(cannot remove owner)</span>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <delete-confirmation-dialog
      v-model="deleteDialog.show"
      title="Confirm team member deletion"
      :text="deleteDialog.text"
      :onDelete="deleteDialog.action"
    />

    <!-- <div class="my-1">
      <v-icon size="small" icon="mdi-arrow-left" color="grey-darken-1"/>
      <router-link :to="{ path: '/' }">
        <span class="light--text">Back to all projects</span>
      </router-link>
    </div> -->
  </div>
</template>

<script>
import store from '@/store'
import WorkflowDialog from '@/components/WorkflowDialog'
import InviteTeamMemberDialog from '@/components/InviteTeamMemberDialog'
import DashboardWorkflowCard from '@/components/DashboardWorkflowCard'
import NavigationTop from '@/components/NavigationTop'
// import DashboardAiProject from '@/components/DashboardAiProject'
// import GoalList from '@/components/GoalList'
import projectApi from '@/api/projectApi'
import { mapState, mapGetters } from 'vuex'
import DeleteConfirmationDialog from '@/components/DeleteConfirmationDialog'

export default {
  components: {
    WorkflowDialog,
    InviteTeamMemberDialog,
    DashboardWorkflowCard,
    NavigationTop,
    DeleteConfirmationDialog
    // GoalList
    // DashboardAiProject
  },
  props: {},
  data () {
    return {
      deleteDialog: {
        show: false,
        text: 'Are you sure want to remove the team member?',
        action: null
      },
      projectMemberHeaders: [
        { title: 'E-mail', key: 'email' },
        { title: 'Name', key: 'name' },
        { title: 'Company', key: 'company' },
        { title: 'Team/ Job Title', key: 'jobTitle' },
        { title: 'Actions', sortable: false, key: 'actions' }
      ]
    }
  },
  computed: {
    ...mapState({
      workflows: state => state.workflows.workflows,
      listTeamMembers: state => state.teamMembers.teamMembers,
      currentUser: state => state.user.user,
      userInfo: state => state.userInfo,
      subscriptionAccessType: state => state.payments.subscriptionAccessType
    }),
    ...mapGetters({
      project: 'projectMemberships/activeProject',
      loadingState: 'loading/getLoadingState'
    }),
    activeMembers () {
      if (!Array.isArray(this.listTeamMembers) || !this.listTeamMembers.length) {
        return []
      }

      return this.listTeamMembers.filter(({ lastLogin }) => lastLogin)
    },

    pendingMembers () {
      if (!Array.isArray(this.listTeamMembers) || !this.listTeamMembers.length) {
        return []
      }

      return this.listTeamMembers.filter(({ lastLogin }) => !lastLogin)
    },

    starredWorkflows () {
      const res = []
      for (const workflow of (this.workflows || [])) {
        if (workflow.starred) {
          res.push(workflow)
        }
      }
      return this.sortWorkflows(res)
    },

    notStarredWorkflows () {
      const res = []
      for (const workflow of (this.workflows || [])) {
        if (!workflow.starred) {
          res.push(workflow)
        }
      }
      return this.sortWorkflows(res)
    }
  },

  watch: {
    listTeamMembers: {
      handler (newList) {
        if (!this.userInfo) {
          return
        }

        const isUserInList = newList?.some(member => member.user?.email === this.userInfo?.toLowerCase())

        if (!isUserInList) {
          store.dispatch('projectMemberships/listProjectMembershipsForCurrentUser')
          this.$router.replace('/404')
        }
      },
      deep: true
    }
  },

  methods: {
    isProjectOwner: (teamMember, project) => teamMember.userId === project?.organisation?.userId,
    isLoggedInUser (teamMember) {
      return teamMember.userId === this.currentUser?.id
    },
    showDeleteTeamMemberDialog (router, item, projectId) {
      this.deleteDialog = {
        show: true,
        text: this.isLoggedInUser(item)
          ? 'You are about to remove yourself from this project and will not be able to access its workflows anymore.'
          : 'Are you sure want to remove the team member?',
        action: () => this.deleteTeamMember(router, item, projectId)
      }
    },
    deleteTeamMember: projectApi.deleteTeamMember,
    userAddGoal () {
      this.$refs.goalList.userAddGoal()
    },

    async updateGoals (goals) {
      const updatedProject = JSON.parse(JSON.stringify(this.project))
      updatedProject.goals = goals
      await projectApi.updateProject(updatedProject)
    },

    editWorkflow (item) {
      this.$refs.dialogWorkflow.setItem(Object.assign({}, item))
      this.$refs.dialogWorkflow.openWorkflowDialog()
    },

    sortWorkflows (workflows) {
      return [...workflows].sort((a, b) => {
        return new Date(b.updatedAt) - new Date(a.updatedAt)
      })
    }
  }
}
</script>

<style scoped>
.highlight-owner > td {
  font-weight: bold;
}
</style>
